import React, { useState, useEffect } from 'react';
import axios from '../axios';
import { useParams, useNavigate } from 'react-router-dom';
import {
    Container,
    Form, FormBtn, FormCover, H1, H3, MediumSpacing
} from "../../styles";
const CourseUpdate = () => {
    const {id} = useParams();
    const navigate = useNavigate();
    const [course, setCourse] = useState({
        name: '',
        code: ''
    });
    useEffect(() => {
        axios.get(`/courses/${id}/`)
            .then(response => {
                setCourse(response.data);
            })
            .catch(error => {
                console.error("There was an error fetching the course data!", error);
            });
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setCourse({
            ...course,
            [name]: value
        });
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        axios.put(`/courses/update/${id}/`, course)
            .then(response => {
                navigate('/courses');
            })
            .catch(error => {
                console.error("There was an error updating the course data!", error);
            });
    };

    return (
        <Container>
            <FormCover>
            <H3>Update Course</H3>
                <MediumSpacing/>
            <Form onSubmit={handleSubmit}>
                <div>
                    <label>Course Name:</label>
                    <br/>
                    <input
                        type="text"
                        id="name"
                        name="name"
                        value={course.name}
                        onChange={handleChange}
                    />
                </div>
                                <MediumSpacing/>

                <div>
                    <label>Course Code:</label>
                    <br/>

                    <input
                        type="text"
                        id="code"
                        name="code"
                        value={course.code}
                        onChange={handleChange}/>
                </div>
                <FormBtn type="submit">Update Course</FormBtn>
            </Form>
                </FormCover>
        </Container>
    );
};

export default CourseUpdate;